import '../../service-worker/push-worker.js';

export const registerBrowser = () => {
  UA.then((sdk) => {
    sdk.register();
  });
};

export const setNamedUser = (userid) => {
  UA.then((sdk) => {
    sdk.getChannel().then((channel) => {
      channel.namedUser.set(userid);
    });
  });
};
